import { render, staticRenderFns } from "./BA-alertView.vue?vue&type=template&id=31258c6a&scoped=true"
import script from "./BA-alertView.vue?vue&type=script&lang=js"
export * from "./BA-alertView.vue?vue&type=script&lang=js"
import style0 from "./BA-alertView.vue?vue&type=style&index=0&id=31258c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31258c6a",
  null
  
)

export default component.exports